// extracted by mini-css-extract-plugin
module.exports = {"root":"Alert_root__3AEBm","icon":"Alert_icon__2k-67","warning":"Alert_warning__1jm6D","error":"Alert_error__2LW07"};